export default __webpack_public_path__ + "static/media/ganesh.75d153c1.png";